import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AppRoute } from 'app/app-layout/constants';
import { TokenInterface } from 'app/core/authentication/models/token.model';
import { AuthService } from 'app/core/authentication/services/auth.service';
import { RouterRequest } from 'app/core/browser/models/router-request.model';
import { BrowserService } from 'app/core/browser/services/browser.service';
import { Observable, Observer, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * Prevent unauthorized activating and loading of routes
 * @class AuthenticationGuard
 */
@Injectable()
export class AuthenticationGuard implements CanActivate, OnDestroy {

  private readonly _subscriptionDestroyer: Subject<boolean> = new Subject<boolean>();

  constructor(private readonly _browserService: BrowserService, private readonly _authService: AuthService) {}

  public ngOnDestroy(): void {
    this._subscriptionDestroyer.next(true);
    this._subscriptionDestroyer.complete();
  }

  /**
   * True when token is present
   * @method canActivate
   */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const observable: Observable<Readonly<TokenInterface>> = this._authService.getToken();

    // redirect to login page if token is not present
    observable
    .pipe(
      takeUntil(this._subscriptionDestroyer))
    .subscribe((authToken: TokenInterface) => {
      // TODO: could put another guard in if authToken.exp is less than current time
      if (!authToken || !authToken.exp) {
        this._browserService.to(new RouterRequest({ route: AppRoute.login }));
        return Observable.create((observer: Observer<boolean>) => { observer.next(false); });
      }
    });

    return Observable.create((observer: Observer<boolean>) => { observer.next(true); });
  }
}
